import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: config.apiBase,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('comsapp_token');
  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

// Handle 401 globally — clear token and redirect
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const requestUrl = String(err.config?.url || '');
      const message = String(err.response?.data?.message || '').toLowerCase();

      // Only force sign-out when the token/session is actually invalid.
      const isAuthBootstrap = requestUrl.includes('/auth/me');
      const isTokenError =
        message.includes('token') ||
        message.includes('authentication required') ||
        message.includes('user not found or inactive');

      if (isAuthBootstrap || isTokenError) {
        localStorage.removeItem('comsapp_token');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
